import { Tooltip, IconButton, ButtonGroup } from "@mui/material";
import EditNotificationsOutlinedIcon from '@mui/icons-material/EditNotificationsOutlined';
import NotificationImportantOutlinedIcon from '@mui/icons-material/NotificationImportantOutlined';
import { useTranslation } from "react-i18next";
import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutline';

const defaultRender = (value) => (value ? value : '--');

const createAlertCell = ({ handleOpen, handleEdit, handleDeleteOpen, t }) => {
    return [
        { title: t("id"), field: "id", render: defaultRender },
        { title: t("symbol"), field: "symbolId", render: defaultRender },
        { title: t("condition"), field: "condition", render: defaultRender },
        { title: t("hitPrice"), field: "hitPrice", render: defaultRender },
        { title: t("hitDateTime"), field: "hitDateTime", render: defaultRender },
        { title: t("status"), field: "enabled", render: defaultRender },
        {
            title: (<Tooltip title={t("createAlert")}><IconButton onClick={handleOpen}><AddCircleOutlineIcon sx={{ fontSize: "20px" }} /></IconButton></Tooltip>),
            field: "actions",
            render: (row) => (
                <ButtonGroup variant="outlined" size="small">
                    <Tooltip title={t("editAlert")}>
                        <IconButton onClick={() => handleEdit(row)}><EditNotificationsOutlinedIcon sx={{ fontSize: "16px", color: "#1976D2" }} /></IconButton>
                    </Tooltip>

                    <Tooltip title={t("deleteAlert")}>
                        <IconButton onClick={() => handleDeleteOpen(row)}><NotificationImportantOutlinedIcon sx={{ fontSize: "16px", color: "#D32F2F" }} /></IconButton>
                    </Tooltip>
                </ButtonGroup>
            ),
        },
    ];
};

const AlertCellConfig = ({ handleOpen = () => {}, handleEdit = () => {}, handleDeleteOpen = () => {} }) => {
    const { t } = useTranslation();
    return createAlertCell({ handleOpen, handleEdit, handleDeleteOpen, t }); 
};


export default AlertCellConfig;
